import axios from "../../../axios";

// export function FetchSearchResult(payload: any) {
//   let response = axios.post(`/products/search/`, payload);
//   return response;
// }

export function FetchSearchResult({
  category_code,
  anonymous_id,
  tag_ids = [],
  dynamic_filter_ids = [],
}: {
  category_code: string;
  anonymous_id?: string | null;
  tag_ids?: number[];
  dynamic_filter_ids?: number[];
}) {
  const data: any = {
    search_term: category_code,
    ...(anonymous_id && { anonymous_id }),
    ...(tag_ids.length > 0 && { tag_ids: tag_ids }),
    ...(dynamic_filter_ids.length > 0 && {
      dynamic_filter_ids: dynamic_filter_ids,
    }),
  };

  return axios.post(`/products/search/`, data);
}
